/** HVAC allocation groups /metering/fee/conditioningSharing */
export default {
  conditioningSharing: {
    phGroupId: 'Group ID',
    phGroupName: 'Group name',
    phShareType: 'Allocation method',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    listTitle: 'HVAC allocation groups',
    btnAdd: 'Add',
    sortDefault: 'Default sort',
    colId: 'Group ID',
    colName: 'Group name',
    colShareType: 'Method',
    colTenantCount: 'Tenants',
    colAirCount: 'Indoor units',
    colUpdateTime: 'Updated',
    colActions: 'Actions',
    opDetail: 'Details',
    opEdit: 'Edit',
    opDelete: 'Delete',
    emptyDesc: 'No data',
    dialogAddTitle: 'Add HVAC allocation group',
    dialogEditTitle: 'Edit HVAC allocation group',
    formName: 'Group name',
    formShareType: 'Method',
    phFormName: 'Enter group name',
    phFormShareType: 'Select method',
    btnCancel: 'Cancel',
    btnConfirm: 'OK',
    btnSubmitting: 'Submitting...',
    shareTypeArea: 'By floor area',
    shareTypeEnergy: 'By energy use',
    msgFetchFail: 'Failed to load data',
    msgFetchListFail: 'Failed to load groups',
    msgNoViewPermission: 'No view permission',
    msgNoAddEditPermission: 'No create/edit permission',
    msgNoDeletePermission: 'No delete permission',
    msgExportEmpty: 'Nothing to export',
    msgExportOk: 'Exported {count} row(s)',
    msgExportFail: 'Export failed',
    exportSheetName: 'HVAC sharing',
    exportFilePrefix: 'hvac_sharing_',
    confirmDeleteTitle: 'Notice',
    confirmDeleteMsg: 'Deleting removes linked tenants and HVAC units. Continue?',
    confirmOk: 'OK',
    confirmCancel: 'Cancel',
    msgDeleteOk: 'Deleted',
    msgDeleteFail: 'Delete failed',
    confirmGroupTitle: 'Notice',
    confirmGroupAdd: 'Create this HVAC group?',
    confirmGroupEdit: 'Save changes to this group?',
    msgAddOk: 'Created',
    msgEditOk: 'Updated',
    msgAddFail: 'Create failed',
    msgEditFail: 'Update failed',
    ruleNameRequired: 'Enter group name',
    ruleNameLen: '1–50 characters',
    ruleShareTypeRequired: 'Select allocation method'
  }
}
